import { render, staticRenderFns } from "./sponsorship_general.vue?vue&type=template&id=29d5007f&"
import script from "./sponsorship_general.vue?vue&type=script&lang=js&"
export * from "./sponsorship_general.vue?vue&type=script&lang=js&"
import style0 from "./sponsorship_general.vue?vue&type=style&index=0&id=29d5007f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports